export { SliderListElementInterface } from './sliderListElement.interface';
export { SliderDTO } from './slider.dto';
